import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const GENERATE_CANDIDATE_CONTRACTS = gql`
    mutation GenerateCandidateContracts($candidateUuid: ID!) {
        generateCandidateContracts(candidateUuid: $candidateUuid)
    }
`;

const useGenerateCandidateContracts = () => {
    const [mutate, { loading, error }] = useMutation(GENERATE_CANDIDATE_CONTRACTS);

    const generateCandidateContracts = async (candidateUuid) => {
        return mutate({
            variables: { candidateUuid },
        });
    };

    return {
        generateCandidateContracts,
        loading,
        error,
    };
};

export default useGenerateCandidateContracts;
